import './TitleBar.css'

import { NavLink } from 'react-router'

import { Button } from '#design-system/component/Button/Button'
import { SidebarSimple } from '#design-system/icons/sidebar-simple'

interface TitleBarProps {
  isNavCollapsed?: boolean
  onToggleNav?: () => void
  onPeekStart?: () => void
  onPeekEnd?: () => void
  title: string
  /** Ancestor → self trail; when present it replaces the plain title. */
  breadcrumb?: readonly { label: string; to: string }[] | undefined
}

export const TitleBar = ({
  isNavCollapsed = false,
  onToggleNav,
  onPeekStart,
  onPeekEnd,
  title,
  breadcrumb,
}: TitleBarProps) => (
  <header className="title-bar">
    <div className="peek-trigger" onMouseEnter={onPeekStart} onMouseLeave={onPeekEnd}>
      <Button
        actionRole="ghost"
        aria-controls={onToggleNav !== undefined ? 'shell-nav' : undefined}
        aria-expanded={onToggleNav !== undefined ? !isNavCollapsed : undefined}
        aria-label="Toggle nav"
        icon={<SidebarSimple />}
        {...(onToggleNav && { onClick: onToggleNav })}
      />
    </div>
    {breadcrumb?.length ? (
      <nav aria-label="Breadcrumb" className="breadcrumb">
        {breadcrumb.map((crumb, index) =>
          index === breadcrumb.length - 1 ? (
            <span key={crumb.to} aria-current="page" className="crumb">
              {crumb.label}
            </span>
          ) : (
            <NavLink key={crumb.to} className="crumb" end to={crumb.to}>
              {crumb.label}
            </NavLink>
          ),
        )}
      </nav>
    ) : (
      <span className="page-title">{title}</span>
    )}
  </header>
)
